"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.addUnChangedBannerLayerToProgram = exports.addAudioPresentersToProgramLayer = void 0;
var _constants = require("@studio/constants");
/**
 * This will add audio sources to program for any unMuted presenter given the attendeeId
 * @param {Object} layers takes a layers of a program to validate
 * @param {Object} sources with audio presenter sources
 * @return {Object} returns an updated program object that has been validated
 */
var addAudioPresentersToProgramLayer = exports.addAudioPresentersToProgramLayer = function addAudioPresentersToProgramLayer(layers, sources) {
  var filterAudioPresenter = sources.filter(function (s) {
    return s && s.type === _constants.AUDIO_PRESENTER;
  });
  var audioPresenterLayer = filterAudioPresenter.map(function (source) {
    return {
      _id: source._id,
      source: source,
      layer: {}
    };
  });
  layers = layers.concat(audioPresenterLayer);
  return layers;
};

/**
 * This is expected to retain the current banner in state.
 * @param {Object} withAudioPresenterLayer a just updated program object that has the audioPresenter validated
 * @param {Object} program current program in state
 * @return {Object} returns an updated program object that has the correct banner layer
 */

var addUnChangedBannerLayerToProgram = exports.addUnChangedBannerLayerToProgram = function addUnChangedBannerLayerToProgram(withAudioPresenterLayer, program) {
  return withAudioPresenterLayer.map(function (layer) {
    var source = layer.source;
    // Updates the withAudioPresenterLayer with the correct program layer
    if (source && (source === null || source === void 0 ? void 0 : source.type) === 'banner') {
      var programLayer = program === null || program === void 0 ? void 0 : program.layers.find(function (programLayer) {
        return (programLayer === null || programLayer === void 0 ? void 0 : programLayer.source._id) === source._id;
      });

      /** What happens if programLayer is undefined? */
      return programLayer || layer;
    }
    return layer;
  });
};